import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
} from "@chakra-ui/react";
import React from "react";

type SideDrawerProps<Item> = {
  isOpen: boolean;
  onClose: () => void;
  item: Item | undefined;
  isLoading?: boolean;
  size?: string;
  hideCloseButton?: boolean;
  children?: (_: { item?: Item, isLoading?: boolean }) => React.ReactNode;
  header?: (_: { item?: Item, isLoading?: boolean }) => React.ReactNode;
};

export default function SideDrawer<Item>({
  isOpen,
  onClose,
  item,
  children = undefined,
  header = undefined,
  isLoading = false,
  size = "lg",
  hideCloseButton = false,
}: SideDrawerProps<Item>) {
  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size={size}>
      <DrawerOverlay />
      <DrawerContent>
        {!hideCloseButton && <DrawerCloseButton mt="10px" />}
        {header && (
          <DrawerHeader paddingBottom="4" fontSize="md" fontWeight="bold" borderBottomWidth="1px">
            {header({ item, isLoading })}
          </DrawerHeader>
        )}
        <DrawerBody pt={header ? "4" : 10} pb={8}>
          {children && children({ item, isLoading })}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
